import React from 'react';
import { useDispatch } from 'react-redux';

import ModalPortal from '@/src/components/common/Modal/ModalPortal';
import RenameModalContainer from '@/src/components/project/Common/Modals/RenameModal/RenameModalContainer';
import { useRename } from '@/src/components/project/Library/api/rename';
import { useToggle } from '@/src/hooks/useToggle';

const Rename = ({ file, onClick = null }) => {
  const dispatch = useDispatch();
  const [isModalOpen, toggleIsModalOpen] = useToggle(false);

  const renameMutation = useRename();

  const handleToggle = () => {
    dispatch({ type: 'UPDATE_FILES_SELECTED', selected: file });
    toggleIsModalOpen(true);
  };

  const handleRename = async (updatedName) => {
    const response = await renameMutation.mutateAsync({
      name: updatedName,
      libraryItemId: file.id,
      version: file.version,
    });

    console.log({ response });
    toggleIsModalOpen(false);

    if (onClick) {
      onClick();
    }
  };

  return (
    <React.Fragment>
      <a onClick={handleToggle}>
        Rename
        <i className="material-icons">edit</i>
      </a>

      {isModalOpen && (
        <ModalPortal>
          <RenameModalContainer
            customSave={handleRename}
            selected={file}
            onCancel={() => toggleIsModalOpen(false)}
          />
        </ModalPortal>
      )}
    </React.Fragment>
  );
};

export default Rename;
